import * as monaco from 'monaco-editor';
import EditorWorker from 'monaco-editor/editor/editor.worker?worker';
import TypeScriptWorker from 'monaco-editor/language/typescript/ts.worker?worker';
import {
  API_TYPES,
  layerTypes,
  paramTypes,
  type ScriptLayers,
  type ScriptParams,
} from '$lib/core/script';

self.MonacoEnvironment = {
  getWorker: (_id, label) =>
    label === 'typescript' || label === 'javascript' ? new TypeScriptWorker() : new EditorWorker(),
};

const defaults = monaco.typescript.javascriptDefaults;
defaults.setCompilerOptions({
  target: monaco.typescript.ScriptTarget.ES2020,
  allowNonTsExtensions: true,
  checkJs: true,
  noLib: false,
  lib: ['es2020'],
});
defaults.addExtraLib(API_TYPES, 'file:///draw-api.d.ts');

const PARAMS_LIB = 'file:///draw-params.d.ts';
let paramsLib = defaults.addExtraLib(paramTypes([]), PARAMS_LIB);

/** Declares the open drawing's params, so `params.` completes their names. */
export function declareParams(params: ScriptParams): void {
  paramsLib.dispose();
  paramsLib = defaults.addExtraLib(paramTypes(params), PARAMS_LIB);
}

const LAYERS_LIB = 'file:///draw-layers.d.ts';
let layersLib = defaults.addExtraLib(layerTypes([]), LAYERS_LIB);

/** Declares the open drawing's layers, so `layers.` completes their names. */
export function declareLayers(layers: ScriptLayers): void {
  layersLib.dispose();
  layersLib = defaults.addExtraLib(layerTypes(layers), LAYERS_LIB);
}

export { monaco };
